import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createParty } from '../controller/client/PartyClient';
import { useFunctionsEmulatorOnLocal } from '../firebase/firebase';
import { AppActions, AppMapProps } from '../redux/reducer';
import './lobby/lobby.scss';
import { useAppState } from '../state/AppState';
import { getIdToken } from '../controller/PartyDB';
import HomeButton from './common/HomeButton';
import { Button, Input, Select } from 'antd';
import { Stream, StreamType } from '../PartyClientResponse';
import InputRowItem from './common/InputRowItem';
import slugify from '@sindresorhus/slugify';

const KEY_PREVIOUS_TWITCH = 'KEY_PREVIOUS_TWITCH';

const CreateParty = () => {
  useFunctionsEmulatorOnLocal();
  const history = useHistory();
  const { user } = useAppState();

  // const [streamType, setStreamType] = useState<StreamType>(StreamType.Twitch);
  const [twitchId, setTwitchId] = useState<string>(
    localStorage.getItem('KEY_PREVIOUS_TWITCH') || ''
  );
  // const [youtubeId, setSetYoutubeId] = useState<string>('');
  // const [backroomStreamId, setBackroomStreamId] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  // TODO: Handle errors better (and figure out the typing)
  const [error, setError] = useState<any | null>(null);

  const constructStream = (): Stream => {
    return {
      type: StreamType.Twitch,
      twitchId,
    };
    // if (streamType === StreamType.Twitch) {
    // } else if (streamType === StreamType.Youtube) {
    //   return {
    //     type: StreamType.Youtube,
    //     youtubeId,
    //   };
    // }
    // return {
    //   type: StreamType.Backroom,
    //   backroomStreamId,
    //   audioSource: 'audio-follows-video',
    // };
  };

  const onCreateParty = async () => {
    let stream = constructStream();
    setLoading(true);
    try {
      const party = await createParty({
        idToken: await getIdToken(),
        name: twitchId,
        mainStage: {
          name: 'Main stage',
          videoFeed: {
            twitchId,
          },
          spotlight: null,
          stream,
          // streamType: streamUrl ? 'streamUrl' : 'twitchId',
          areas: {},
        },
      });
      localStorage.setItem(KEY_PREVIOUS_TWITCH, twitchId);
      setLoading(false);
      setError(null);
      if (party) history.push(party.slug);
    } catch (e) {
      console.log(e);
      setLoading(false);
      setError(e);
    }
  };

  return (
    user && (
      <div className='onboarding-container'>
        <HomeButton />
        <div className='onboarding-card'>
          <h2 style={{ marginBottom: 24 }}>Create a party</h2>
          {/* <p>You only need a Twitch channel id, and you are set! </p>
          <InputRowItem
            left={
              <Select
                value={$enum(StreamType).getKeyOrDefault(streamType)}
                onSelect={(value) => setStreamType(StreamType[value])}
                style={{ width: '100%' }}>
                {$enum(StreamType)
                  .getEntries()
                  .map(([key, value]) => (
                    <Select.Option value={key}>{key}</Select.Option>
                  ))}
              </Select>
            }
            right='stream source'
          /> */}
          {/* {streamType === StreamType.Twitch && ( */}
          <InputRowItem
            left={
              <Input
                value={twitchId}
                onChange={(event) => setTwitchId(event.target.value)}
                autoFocus={true}
                style={{ textAlign: 'center' }}
              />
            }
            right='your channel name'
          />
          <div
            style={{
              marginTop: 12,
              marginBottom: 12,
              paddingTop: 18,
              paddingBottom: 18,
              borderRadius: 30,
              width: '100%',
              textAlign: 'center',
              backgroundColor: '#d4d2d2',
            }}>{`backroom.social/${slugify(twitchId, { separator: '-' })}`}</div>
          {/* )} */}
          {/* {streamType === StreamType.Youtube && (
            <InputRowItem
              left={
                <Input
                  value={youtubeId}
                  onChange={(event) => setSetYoutubeId(event.target.value)}
                  autoFocus={true}
                  style={{ textAlign: 'center' }}
                />
              }
              right='youtube id'
            />
          )}
          {streamType === StreamType.Backroom && (
            <InputRowItem
              left={
                <Input
                  value={backroomStreamId}
                  onChange={(event) => setBackroomStreamId(event.target.value)}
                  autoFocus={true}
                  style={{ textAlign: 'center' }}
                />
              }
              right='stream id'
            />
          )} */}

          <div>{error && (error.message || String(error))}</div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <Button
              type='dashed'
              style={{
                marginTop: 20,
                height: 80,
                alignItems: 'center',
                justifyContent: 'center',
                display: 'inline-flex',
                width: '48%',
              }}
              href='/'>
              cancel
            </Button>
            <Button
              type='primary'
              style={{
                marginTop: 20,
                height: 80,
                alignItems: 'center',
                justifyContent: 'center',
                display: 'inline-flex',
                width: '48%',
              }}
              loading={loading}
              onClick={onCreateParty}>
              Create party
            </Button>
          </div>
        </div>
      </div>
    )
  );
};

export default connect(AppMapProps, AppActions)(CreateParty);
